import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical, X } from 'lucide-react';
import { fixImageUrl } from '../lib/imageUtils';

/**
 * One draggable image card in the admin listing form.
 * Drag handle = the small grip icon top-left.
 * Click X to remove.
 */
export const SortableImage = ({ id, url, idx, onRemove }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    zIndex: isDragging ? 50 : 'auto',
    opacity: isDragging ? 0.6 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="relative group aspect-square select-none"
      data-testid={`sortable-image-${idx}`}
    >
      <img
        src={fixImageUrl(url)}
        alt={`Preview ${idx + 1}`}
        className="w-full h-full object-cover border-2 border-border"
        onError={(e) => {
          e.target.src = 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="%23f0f0f0" width="100" height="100"/><text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="%23999" font-size="12">Error</text></svg>';
        }}
        draggable={false}
      />

      {/* Drag handle */}
      <button
        type="button"
        {...attributes}
        {...listeners}
        className="absolute top-1 left-1 w-7 h-7 bg-black/70 text-white flex items-center justify-center cursor-grab active:cursor-grabbing opacity-80 hover:opacity-100"
        title="Drag to reorder"
        data-testid={`drag-handle-${idx}`}
      >
        <GripVertical className="w-4 h-4" />
      </button>

      {/* Remove button */}
      <button
        type="button"
        onClick={() => onRemove(url)}
        className="absolute -top-2 -right-2 w-6 h-6 bg-destructive text-white rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity shadow-md"
        data-testid={`remove-image-${idx}`}
      >
        <X className="w-3 h-3" />
      </button>

      {/* Cover badge for first image */}
      {idx === 0 && (
        <span className="absolute bottom-0 left-0 right-0 bg-brand-gold text-brand-brown text-[10px] text-center py-0.5 font-heading uppercase tracking-widest font-bold">
          Cover
        </span>
      )}
    </div>
  );
};
